import { SummaryIcon as Container } from './styles'

export function SummaryIcon({ childre, icon: Icon, ...rest }) {
  return <Container as={Icon} size={35} {...rest} />
}
